import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Header from "../components/Header"
import Layout from "../components/Layout"
import { btn, btnPrimary } from "../ds/button.module.css"
import { WhiteArrowRight } from "../ds/Shapes"

export default function index() {
  return (
    <Layout
      title="Event Sponsor Content & Brand Placement - Premagic"
      description="Maximize sponsor ROI with in-gallery brand placement. Smart sponsorship integration that engages attendees and tracks brand interactions."
      keywords={[
        "event sponsored content, in-gallery sponsorship, sponsor brand placement, event sponsor marketing, sponsor ROI tracking, branded event content, sponsor engagement analytics, event monetization platform, digital sponsorship solutions, sponsor visibility events, brand activation events, sponsored photo galleries, event advertising platform, sponsor content integration, brand placement analytics",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Sponsored Content", url: "/sponsored-content/" },
      ]}
    >
      <div className="">
        <div className="" style={{ backgroundColor: "#7251F4" }}>
          <Header isWhiteLogo />
        </div>

        <section
          className="py-10 h-[calc(100vh-127px)] flex items-center"
          style={{ backgroundColor: "#7251F4" }}
        >
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="md:flex items-center justify-between">
              <div className="md:w-1/2 flex flex-col justify-between text-left">
                <h1 className="text-3xl md:text-5xl font-bold mb-10 text-white !leading-[40px] md:!leading-[60px]">
                  Maximize your <br />
                  <span style={{ color: "#61F2C2" }}>sponsors’ ROI</span>
                </h1>
                <p className="text-white">
                  Drive more value for your sponsors & <br /> exhibitors while{" "}
                  <span style={{ color: "#61F2C2" }}>
                    boosting event revenue
                  </span>{" "}
                  with <br className="hidden md:block" /> enhanced ROI
                  offerings.
                </p>
                <Link
                  to="/request-a-demo/"
                  className={`${btn} ${btnPrimary} text-xs mt-4 md:mt-10 mb-10 md:mb-0 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Get started</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
              </div>
              <div className="md:w-[600px] w-full sm:w-[450px] mx-auto">
                <StaticImage
                  src="../images/sponsored-content/sponsored-hero.png"
                  alt="sponsored-content-events-ai.jpg-sponsored"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="md:pt-10">
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="flex flex-col md:flex-row flex-col-reverse">
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pr-10 md:mt-0">
                {/* <h4
                  className="font-bold text-2xl mb-5"
                  style={{ color: "#7251F4" }}
                >
                  How it works
                </h4> */}
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-4"
                  style={{ color: "#7251F4" }}
                >
                  How does sponsored content maximize event sponsor ROI?
                </h2>
                <p>
                  Premagic's sponsor content feature allows sponsors and
                  exhibitors to run ads in your own specialized ad space! Get
                  more exposure, new leads, and sales today!
                </p>
              </div>
              <div className="md:w-1/2 md:pl-10 mt-10 md:mt-0 -mr-10 md:mr-0">
                <StaticImage
                  src="../images/sponsored-content/two-man.png"
                  height={500}
                  alt="sponsored-content-events-ai"
                />
              </div>
            </div>
            <div className="md:flex mt-20">
              <div className="md:w-1/2 md:pr-10">
                <StaticImage
                  src="../images/sponsored-content/gallery.png"
                  alt="sponsored-content-events-ai-gallery"
                />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center text-left mt-10 md:mt-0 md:pl-10">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  In-Gallery Logos and Videos
                </h2>
                <p className="md:pr-32">
                  Insert sponsored images or videos between attendee photo
                  galleries, while adding multiple watermarks to attendee photos
                  for increased brand visibility.
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-20 md:my-20 flex-col-reverse">
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pr-10 mt-10 md:mt-0">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Clickable Sponsor <br /> Content
                </h2>
                <p className="md:pr-32">
                  Drive direct traffic to Sponsor websites by embedding
                  hyperlinked logos, images and videos in the event photo
                  galleries.
                </p>
              </div>
              <div className="md:w-1/2 md:pl-10">
                <StaticImage
                  src="../images/sponsored-content/sponsored-post.png"
                  alt="sponsored-content-events-ai-post"
                />
              </div>
            </div>
            <div className="md:flex mb-20 mt-20 md:mt-0">
              <div className="md:w-1/2 md:pr-10">
                <StaticImage
                  src="../images/sponsored-content/multi-function.png"
                  alt="sponsored-content-events-ai-multi-funtion"
                />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pl-10 mt-10 md:mt-0">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Multi-Tier <br /> Sponsorship on <br /> Gallery
                </h2>
                <p className="md:pr-32">
                  Showcase sponsors across different tiers with customizable
                  logo placements and categorizations within
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row md:my-20 flex-col-reverse">
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pr-10 mt-10 md:mt-0">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Track Post-Event <br /> Sponsor <br /> Impressions
                </h2>
                <p className="md:pr-32">
                  View and export comprehensive insights and reports on your
                  sponsorship performance through the analytics dashboard.
                </p>
              </div>
              <div className="md:w-1/2 md:pl-10">
                <StaticImage
                  src="../images/sponsored-content/insight.png"
                  alt="sponsored-content-events-ai-insight"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="my-20">
          <div className="px-5 md:px-0 mx-auto flex py-10 items-center flex-wrap md:w-[1080px]">
            <div className="w-1/2 md:w-1/4 text-center mb-20 md:mb-0">
              <StaticImage
                class="w-24"
                src="../images/metric_icon4.png"
                alt="sponsored-content-events-ai-metric"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                1.84%
              </h4>
              <p>
                increase in <br /> Click-through rates
              </p>
            </div>
            <div className="w-1/2 mb-20 md:mb-0 md:w-1/4 text-center">
              <StaticImage
                class="w-24"
                src="../images/memory-retention.png"
                alt="sponsored-content-events-ai-memory"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                42%
              </h4>
              <p>
                memory
                <br />
                retention
              </p>
            </div>
            <div className="w-1/2 md:w-1/4 text-center">
              <StaticImage
                class="w-20"
                src="../images/roi.png"
                alt="sponsored-content-events-ai-roi"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                70%
              </h4>
              <p>
                increased ROI
                <br />
                for sponsors
              </p>
            </div>
            <div className="w-1/2 md:w-1/4 text-center">
              <StaticImage
                class="w-20"
                src="../images/metric_icon1.png"
                alt="sponsored-content-events-ai-metric"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                2X
              </h4>
              <p>
                more
                <br />
                engagement
              </p>
            </div>
          </div>
        </section>
        <section
          className="py-20 md:py-0 "
          style={{ backgroundColor: "#7251F4" }}
        >
          <div className="px-5 md:px-0 mx-auto md:flex py-10 items-center justify-end md:w-[1080px] relative">
            <div className="md:w-[450px] w-[360px] mx-auto flex flex-col justify-center mb-20 md:mb-0 static lg:absolute left-0 -top-20">
              <StaticImage
                class=""
                src="../images/sponsored-content/footer-banner.png"
                alt="sponsored-content-events-ai-footer-banner"
              />
            </div>
            <div className="md:w-1/2 md:py-14">
              <h4 className="text-white text-center md:text-2xl text-xl">
                <span style={{ color: "#61F2C2" }}>“</span>Thanks to the
                in-gallery sponsor videos, our sponsors are seeing real results.
                They couldn't be happier.
                <span style={{ color: "#61F2C2" }}>”</span>
              </h4>
              <h5
                className="md:text-2xl text-center mt-10 text-lg"
                style={{ color: "#61F2C2" }}
              >
                Malavika Velayanikal
              </h5>
              <p className="text-white md:text-xl text-sm text-center">
                Director of Initiatives & Events, SaaSBOOMi
              </p>
            </div>
          </div>
        </section>
        <div
          className="rounded-2xl xl:w-1/2 w-11/12 mt-20 mx-auto py-12 px-10 mb-10 flex md:items-center items-start md:flex-row flex-col md:justify-between justify-start"
          style={{ backgroundColor: "#7251F4" }}
        >
          <div>
            <h3 className="md:text-4xl text-2xl font-extrabold text-white">
              Ready for turn <br />
              <span style={{ color: "#61F2C2" }}>
                brand visibility
                <br /> into results?
              </span>
            </h3>
            <p className="text-white mt-4 text-lg md:text-2xl">
              Turn brand exposure into measurable <br /> impact.
            </p>
          </div>
          <Link
            to="/request-a-demo/"
            className={`${btn} ${btnPrimary} text-xs mb-10 md:mb-0 relative w-max group md:mt-0 mt-10 mb-0`}
          >
            <span className="mr-4 ml-2">Show me how</span>
            <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
          </Link>
        </div>
      </div>

      {/* Cross-links to related products */}
      <section className="py-16 bg-gray-50">
        <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-black mb-10">
            Explore More Premagic Products
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link
              to="/digital-asset-management/"
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="font-bold text-lg text-black mb-2">
                Digital Asset Management
              </h3>
              <p className="text-sm text-gray-600">
                Secure event photo management with AI organization and sponsor
                placements.
              </p>
            </Link>
            <Link
              to="/smart-photo-distribution-for-seamless-events/"
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="font-bold text-lg text-black mb-2">
                Photo Distribution
              </h3>
              <p className="text-sm text-gray-600">
                AI-powered facial recognition delivers event photos instantly to
                every attendee.
              </p>
            </Link>
            <Link
              to="/create-event-marketing-posters/"
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <h3 className="font-bold text-lg text-black mb-2">
                Marketing Posters
              </h3>
              <p className="text-sm text-gray-600">
                Create personalized, shareable posters that turn attendees into
                promoters.
              </p>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  )
}
